import { render, staticRenderFns } from "./GroupArea.vue?vue&type=template&id=781e658e&scoped=true&"
import script from "./GroupArea.vue?vue&type=script&lang=js&"
export * from "./GroupArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781e658e",
  null
  
)

export default component.exports